import {
  PERMISSION_ACCESS_ADMIN,
  PERMISSION_ACCESS_CONSUMPTION_HISTORY,
  PERMISSION_ACCESS_CONSUMPTION_REPORT,
  PERMISSION_ACCESS_LEVEL_HISTORY,
  PERMISSION_ACCESS_LEVEL_REPORT,
} from "../models/Permission";

export const BLOCK_FEATURE_ON_MOBILE_PERMISSIONS = [
  PERMISSION_ACCESS_ADMIN,
  PERMISSION_ACCESS_CONSUMPTION_HISTORY,
  PERMISSION_ACCESS_LEVEL_HISTORY,
  PERMISSION_ACCESS_LEVEL_REPORT,
  PERMISSION_ACCESS_CONSUMPTION_REPORT,
];
